<template lang="html">
  <root class="admin-signin">

    <div class="container">
      <div class="row">
        <div class="col m4 offset-m4">

            <!-- Sign in -->
            <div class="card">
              <div class="card-content">
                <span class="card-title">Admin Access</span>

                <!-- Form -->
                <div class="input-field">
                  <i class="material-icons prefix">email</i>
                  <input type="email" placeholder="Email" v-model="email">
                </div>

                <div class="input-field">
                  <i class="material-icons prefix">lock</i>
                  <input type="password" placeholder="Password" v-model="password">
                </div>

                <a class="waves-effect waves-light btn" @click="signIn" :disabled="isSending">Sign In</a>
              </div>
            </div>

        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from 'firebase'

export default {
  data: () => {
    return {
      email: '',
      password: '',
      isSending: false
    }
  },

  methods: {

    // Sign in
    signIn() {
      this.isSending = true

      // Anonymous sign in
      firebase.auth().signInAnonymously().then( () => {
        firebase.database().ref('config')
          .once('value')
          .then( configSnap => {
            let config = configSnap.val()

            // Auth check
            let isEmailValid = config.admin.email == this.email
            let isPasswordValid = atob(config.admin.password) == this.password

            if (isEmailValid && isPasswordValid) {

              // Login success
              Materialize.toast('Successfully authenticated', 4000)
              return this.$router.push({ name: 'Dashboard'})
            }

            // Invalid credentials
            Materialize.toast('Invalid login credentials', 4000)
            return this.clearForm()

          }).catch( error => { console.error(error) })
      })
    },

    // Clear form
    clearForm() {
      this.isSending = false
      this.email = ''
      this.password = ''
    }
  }
}
</script>

<style lang="scss">
@import '../../theme';

body {
  background-color: #f6f6f6;
}

.admin-signin {
  padding-top: 8%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/SignIn.vue